import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { FeedbackAthleteAnswerProvider } from '../providers/feedback-athlete-answer-provider';
import { FeedbackAthleteAnswer } from "../../common/models/feedback-athlete-answer";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FeedbackAthleteAnswerResolver implements Resolve<FeedbackAthleteAnswer> {
    constructor(
        private feedbackAthleteAnswerProvider: FeedbackAthleteAnswerProvider
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.feedbackAthleteAnswerProvider.findById(+route.params['feedbackAthleteAnswerId']);
    }
}
